/* Forged Racing — PDP addon box.

   ROUND 33 (Emirali: "a product addon area in each item page and it has to be
   smart ... just like the cart"). Consumes the SAME selector as the cart drawer
   (forged-upsell-select.js) so the two surfaces cannot drift apart.

   Never renders empty: the container ships `hidden` and is only revealed once
   at least one real match has been resolved AND rendered. A box that appears
   and then shows nothing is worse than no box.

   Respects the Round 30 quantity cap by going through window.ForgedCart.addItem
   — the single choke point that surfaces Shopify's 422 when an add exceeds
   available stock. Adding an addon at its stock limit therefore fails honestly
   with the server's own message rather than silently doing nothing. */
(function () {
  'use strict';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sized(url, w) {
    if (!url) return '';
    return url.indexOf('?') === -1 ? url + '?width=' + w : url + '&width=' + w;
  }

  function init() {
    var root = document.querySelector('[data-frg-addons]');
    if (!root) return;
    if (!window.ForgedUpsell || !window.ForgedUpsell.pick) return; /* fail quiet, stay hidden */

    /* ROUND 56: `root` is guarded above, `list` was not — and it is both written
       to (list.innerHTML) and bound (list.addEventListener) below. Same
       null-addEventListener shape Clarity reported. */
    var list = root.querySelector('[data-frg-addons-list]');
    if (!list) return;
    var seedId = parseInt(root.dataset.frgAddonsProduct, 10);

    /* Exclude what's already in the cart so we never suggest a duplicate. If
       the cart call fails we proceed with an empty list rather than abandoning
       the box — worst case a shopper sees something they already have, which is
       a far smaller failure than rendering nothing. */
    fetch('/cart.js')
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .catch(function () { return { items: [] }; })
      .then(function (cart) {
        var inCart = (cart.items || []).map(function (i) { return i.product_id; });
        /* Seed excluded too — a product must never recommend itself. */
        if (seedId) inCart.push(seedId);
        return window.ForgedUpsell.pick({ seedId: seedId, inCartIds: inCart, limit: 3 });
      })
      .then(function (products) {
        if (!products || !products.length) return; /* stays hidden */

        var html = products.map(function (p) {
          /* ROUND 85 T7 — offer the cheapest AVAILABLE variant (shared rule in
             forged-upsell-select.js), not variants[0]. */
          var offer = window.ForgedUpsell.offerFor ? window.ForgedUpsell.offerFor(p) : null;
          var vid = offer ? offer.id : null;
          if (!vid) return '';
          var img = p.featured_image || (p.images && p.images[0]) || '';
          return (
            '<li class="frg-addon">' +
              '<label class="frg-addon__label">' +
                '<input type="checkbox" class="frg-addon__check" data-frg-addon-add="' + esc(vid) + '">' +
                (img ? '<img class="frg-addon__img" src="' + esc(sized(img, 120)) + '" alt="" loading="lazy" width="48" height="48">' : '') +
                '<span class="frg-addon__text">' +
                  '<span class="frg-addon__name">' + esc(p.title) + '</span>' +
                  /* ROUND 50 rule kept: the price shown is the price of the
                     variant actually added. ROUND 85 T7 changes WHICH variant —
                     the cheapest available one, so the shown price is also the
                     lowest you can buy — and adds "From" when the available
                     variants differ in price (Dario's call, Round 85). */
                  '<span class="frg-addon__price">' + (offer.varies ? 'From ' : '') + money(offer.cents) + '</span>' +
                '</span>' +
              '</label>' +
            '</li>'
          );
        }).join('');

        if (!html) return; /* every candidate lacked a variant id — stay hidden */
        list.innerHTML = html;
        root.hidden = false;
      })
      .catch(function () { /* stays hidden */ });

    /* Checkbox-style add, matching the cart upsell's interaction. Checking the
       box adds; the box stays checked as the confirmation. Unchecking does NOT
       remove — removal belongs in the cart, and silently pulling a line out
       from under someone is worse than making them go there. */
    list.addEventListener('change', function (e) {
      var cb = e.target.closest('[data-frg-addon-add]');
      if (!cb || !cb.checked) return;
      var id = parseInt(cb.dataset.frgAddonAdd, 10);
      if (!id) return;
      cb.disabled = true;
      if (window.ForgedCart && window.ForgedCart.addItem) {
        window.ForgedCart.addItem({ id: id, quantity: 1 });
      } else {
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
